import { CogIcon, GraduationCapIcon, MagnetIcon, PlugIcon, WrenchIcon, ZapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: 'Fundamentals of Electrical Engineering',
    summary: 'Introduction, electrical quantities, laws, materials, components, circuits, teaching methods.',
    icon: WrenchIcon,
  },
  {
    number: '2',
    title: 'Electrical Circuits and Circuit Analysis',
    summary: 'DC circuits, network analysis, theorems, AC fundamentals, power, teaching strategies, 15 examples.',
    icon: CogIcon,
  },
  {
    number: '3',
    title: 'Electrical Machines and Electromagnetic Systems',
    summary: 'Electromagnetism, transformers, DC/AC machines, performance, teaching methods, 15 examples.',
    icon: MagnetIcon,
  },
  {
    number: '4',
    title: 'Power Generation, Transmission and Distribution',
    summary: 'Generation types, three-phase systems, transmission, distribution, smart grids, 12 examples.',
    icon: ZapIcon,
  },
  {
    number: '5',
    title: 'Electrical Installations, Protection and Control Systems',
    summary: 'Installations, load analysis, protection, safety, industrial control, PLCs, 12 examples.',
    icon: PlugIcon,
  },
  {
    number: '6',
    title: 'Teaching Electrical Engineering: Methods, Activities & Assessment',
    summary: 'Curriculum planning, teaching methodologies, classroom activities, assessment strategies, 10 projects.',
    icon: GraduationCapIcon,
  },
];
